<template>
  <list-item>
    <link-text :record="record"
               v-if="showCols.titleCol&&showCols.titleCol.showFlag!==false"
               :showCols="dataConfig.showCols"
               propName="titleCol"
               :dataConfig="dataConfig"></link-text>
  </list-item>
</template>

<script lang="ts">
import {ListItem} from 'ant-design-vue';
import {defineComponent} from 'vue';
import i18n from "@/i18n";

export default defineComponent({
  components: {
    ListItem
  },
  label: i18n.global.t('简单列表'),
  columns: [
    {value: 'content', label: i18n.global.t('记录内容')}
  ],
  name: 'commonList',
});
</script>

<script lang="ts" setup>
import {toRefs} from 'vue';
import {useI18n} from "vue-i18n";
import LinkText from "@/gateway-main/commonVue/link-text.vue";

const {t} = useI18n();

interface propTypes {
  record: any,
  dataConfig: any
};
const props = withDefaults(defineProps<propTypes>(), {
  record: {},
  dataConfig: {}
})
const {dataConfig} = toRefs(props);
if (unref(dataConfig)["showCols"] == null) {
  unref(dataConfig)["showCols"] = {
    titleCol: {}
  };
}
const showCols = unref(dataConfig)["showCols"];

</script>
